<template>
    <main v-if="hasStrategyModule" class="onepage-container">
        <Loader :loader="loading" />
        <div class="onepage-header">
            <section class="onepage-content">
                <div class="row">
                    <div class="col-12 col-md-12 col-lg-12">
                        <div class="title-container">
                            <div class="title-content">
                                <div class="title-icon">
                                    <svg
                                        width="25"
                                        height="25"
                                        viewBox="0 0 16 15"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M15.0745 14.6413L11.6371 12.1862L8.1957 14.6413C8.1209 14.6961 8.02853 14.7287 7.92823 14.7287C7.82793 14.7287 7.73556 14.6961 7.65963 14.6401L7.66133 14.6413L4.2228 12.1862L0.784833 14.6413C0.707599 14.6975 0.616435 14.7282 0.522844 14.7293C0.429254 14.7305 0.337432 14.7022 0.258967 14.6479L0.260667 14.6491C0.180281 14.5904 0.114541 14.5117 0.0691258 14.42C0.0237105 14.3282 -1.45188e-05 14.226 6.66582e-09 14.1223V14.1096V14.1102V3.52786V3.5158C6.66582e-09 3.30362 0.0980333 3.11616 0.248767 3.00163L0.250467 3.00043L3.95703 0.353028C4.03183 0.298175 4.1242 0.265625 4.2245 0.265625C4.3248 0.265625 4.41717 0.298175 4.4931 0.354233L4.4914 0.353028L7.9288 2.80814L11.3668 0.353028C11.4416 0.298175 11.5339 0.265625 11.6342 0.265625C11.7345 0.265625 11.8269 0.298175 11.9028 0.354233L11.9011 0.353028L15.6077 3.00043C15.7584 3.11435 15.8559 3.30001 15.8559 3.50917L15.8553 3.53208V3.53087V14.1283C15.8553 14.3459 15.7522 14.5376 15.5952 14.6521L15.593 14.6533C15.5169 14.7052 15.4283 14.7326 15.338 14.7323C15.2423 14.7302 15.1493 14.6984 15.0705 14.6407L15.0722 14.6419L15.0745 14.6413ZM1.13333 3.91544V13.018L3.64707 11.1578V2.05527L1.13333 3.91544ZM8.49603 12.9842L11.08 11.1385V7.02578C11.0551 7.0523 11.0347 7.07822 11.0132 7.10474C10.9491 7.1837 10.8857 7.26267 10.8216 7.33802L10.3966 6.93898C10.4567 6.86363 10.5202 6.78828 10.5842 6.70932C10.6834 6.59238 10.7825 6.46821 10.8891 6.34404L11.0766 6.52487V2.03598L8.49206 3.88169V8.11138C8.57465 8.1066 8.65693 8.09714 8.73856 8.08305L8.72553 8.08486L8.8162 8.6798C8.71636 8.6953 8.61598 8.70656 8.5153 8.71355H8.49773L8.49603 12.9842ZM4.7787 11.1427L7.3627 12.9842V8.07702L7.21423 8.55924C6.95142 8.4684 6.70076 8.34177 6.4685 8.18251L6.48096 8.19034L6.78186 7.67798C6.94903 7.79311 7.14056 7.89378 7.34343 7.96912L7.3627 7.97515V3.88109L4.7787 2.03598V5.83589C4.94643 5.93053 5.08753 6.02396 5.2224 6.12704L5.21106 6.1186L4.88183 6.60805C4.8501 6.58153 4.81497 6.55983 4.77926 6.5327L4.7787 11.1427ZM12.6061 5.8588C12.4665 5.8905 12.3305 5.93778 12.2003 5.99985L12.2134 5.99442V11.1632L14.7231 12.9836V3.87807L12.2094 2.04985V5.34523C12.2825 5.31871 12.3777 5.29159 12.4746 5.26989L12.4927 5.26627L12.6061 5.8588ZM9.35623 7.8769C9.5659 7.76599 9.74666 7.63277 9.90703 7.47605L9.90533 7.47786L10.2805 7.92994C10.0823 8.12162 9.86038 8.28347 9.62086 8.41096L9.60386 8.4194L9.35623 7.8769ZM5.4332 7.19938C5.40146 7.15417 5.36633 7.11258 5.33063 7.06797L5.76243 6.67617L5.8684 6.81179C5.99193 6.9661 6.10526 7.11318 6.23106 7.24579L5.84176 7.6828C5.69939 7.53371 5.56488 7.37635 5.43886 7.21143L5.43093 7.20058L5.4332 7.19938ZM1.81843 7.34404L1.8258 7.3139C1.90287 7.02035 2.0145 6.76417 2.15787 6.5321L2.15163 6.54235L2.61913 6.8799C2.5126 7.05772 2.42647 7.26327 2.37093 7.48268L2.36753 7.49835L2.35733 7.53211L1.81843 7.34404ZM13.6646 6.11197L13.3019 6.50377L12.8985 6.07459L13.2668 5.68882L12.8985 5.30304L13.3019 4.87386L13.6646 5.26567L14.0273 4.87386L14.4307 5.30304L14.0624 5.68882L14.4307 6.07459L14.0273 6.50377L13.6646 6.11197ZM2.5483 6.00949C2.66629 5.89079 2.79739 5.78776 2.93873 5.70268L2.94893 5.69725C3.0447 5.6412 3.15747 5.58875 3.2742 5.54716L3.28837 5.54294L3.46177 6.11558C3.37677 6.14211 3.50427 6.13849 3.42663 6.1837C3.23737 6.26326 3.0753 6.35308 2.92343 6.45856L2.9342 6.45133L2.5483 6.00949Z"
                                            fill="#009ada"
                                        />
                                    </svg>
                                </div>
                                <div class="label-input">
                                    <span>{{ $t('strategy.onepage.winnerField.title') }}</span>
                                </div>
                            </div>
                            <div>
                                <div class="nav-link">
                                    <router-link
                                        :to="{
                                            path: `${
                                                $route.path == '/v2/strategy/onepage'
                                                    ? '/v2/strategy/onepage/compact-mode'
                                                    : '/v2/strategy/onepage'
                                            }`,
                                        }"
                                        tag="button"
                                        class="button-link"
                                    >
                                        <i v-if="$route.path != '/v2/strategy/onepage'" class="fas fa-pen"></i>
                                        <svg
                                            v-else
                                            width="16"
                                            height="13"
                                            viewBox="0 0 16 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M13.9993 0H1.99935C1.25935 0 0.666016 0.593333 0.666016 1.33333V9.33333C0.666016 10.0667 1.25935 10.6667 1.99935 10.6667H5.33268V12H10.666V10.6667H11.9993V9.33333H1.99935V1.33333H13.9993V6.66667H15.3327V1.33333C15.3327 0.593333 14.7327 0 13.9993 0ZM8.66602 4.66667V2.66667H7.33268V4.66667H5.33268V6H7.33268V8H8.66602V6H10.666V4.66667H8.66602ZM15.9993 10L12.9993 13L11.9993 12L13.9993 10L11.9993 8L12.9993 7L15.9993 10Z"
                                                fill="white"
                                            />
                                        </svg>
                                        <span>
                                            {{
                                                $route.path == '/v2/strategy/onepage'
                                                    ? $t('strategy.presentation')
                                                    : $t('strategy.edition')
                                            }}
                                        </span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" align-v="center">
                            <div class="winner-content col-12">
                                <b-form-textarea
                                    class="winner-textarea"
                                    id="textarea"
                                    v-model="onepage.winning_strategy"
                                    lazy-formatter
                                    :state="activeWinner"
                                    :placeholder="$t('strategy.onepage.winnerField.placeholder')"
                                    rows="2"
                                    @blur="putOnepage"
                                    @update="activeWinner = true"
                                    :no-resize="true"
                                    :disabled="validationUserRole"
                                ></b-form-textarea>
                                <ValidationInput :status="activeWinner" size="2rem" />
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="(onepage.winning_strategy && onepage.winning_strategy.length > 0) || onepage.period_start"
                        class="col-12 animated fadeIn d-flex align-items-center"
                    >
                        <DatePicker :onepage="onepage" :disabled="validationUserRole" />
                    </div>
                </div>
            </section>
            <div class="config-and-progress-container">
                <div>
                    <div class="progress-container">
                        <span class="progress-title">{{ $t('strategy.onepage.globalResult') }}</span>
                        <div class="progress-content">
                            <ProgressBar
                                class="progress-bar"
                                :value="onepage.performance == null ? 0 : onepage.performance"
                                height="1.4rem"
                                :label="viewBlockPerformance(onepage.performance)"
                                :labelColor="updateColorPerformance(onepage.performance)"
                                :color="updateColorPerformance(onepage.performance)"
                                :max="maxProgressBar"
                            ></ProgressBar>
                            <span>{{ viewBlockPerformance(onepage.performance) }}</span>
                        </div>
                    </div>
                    <div class="progress-container">
                        <span class="progress-title">
                            {{ $t('strategy.onepage.globalChallengeLevel') }}
                        </span>
                        <div class="progress-content">
                            <ProgressBar
                                class="progress-bar"
                                :value="onepage.challenge == null ? 0 : onepage.challenge"
                                height="1.4rem"
                                :label="viewBlockPerformance(onepage.challenge)"
                                :labelColor="updateColorPerformance(onepage.challenge, 5)"
                                :color="updateColorPerformance(onepage.challenge, 5)"
                                :max="5"
                            ></ProgressBar>
                            <span>{{ labelProgressChallenge }}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <b-dropdown
                        ref="ddown"
                        :text="$t('strategy.onepage.advancedOptions.title')"
                        block
                        no-caret
                        @hide="preventHide"
                        @toggle="toggleConfigDropdown"
                        class="advanced-config"
                        menu-class="advanced-config-menu"
                        right
                        variant="light"
                        v-click-outside="closeAdvancedConfig"
                        :disabled="$route.meta.compactMode || validationUserRole"
                    >
                        <template slot="button-content">
                            <div class="advanced-button">
                                <i class="py-0 fa fa-cog mr-2"></i>
                                <span>{{ $t('strategy.onepage.advancedOptions.title') }}</span>
                            </div>
                        </template>
                        <li>
                            <DropdownCheckbox
                                v-if="unidades"
                                :selectAll="true"
                                @closeModal="closeModalUnitys"
                                @listUpdateAll="updateUnitysAll"
                                @listUpdate="updateUnitys"
                                :data="unidades"
                                :placeholder="$t('strategy.onepage.advancedOptions.units.businessUnits')"
                                headerIcon="fas fa-building"
                            />
                        </li>

                        <li>
                            <DropdownCheckbox
                                v-if="blocos && blocos.length > 0"
                                :selectAll="false"
                                @listUpdate="updateBlocks"
                                :data="blocos"
                                :placeholder="$t('strategy.onepage.advancedOptions.blocks.enableBlocks')"
                                headerIcon="fas fa-cube"
                            />
                        </li>

                        <li>
                            <b-dropdown
                                v-if="onepage.period_start && onepage.period_end"
                                class="unidades-content"
                                text="Block Primary"
                                block
                                variant="white"
                                size="lg"
                                no-caret
                            >
                                <template #button-content>
                                    <b-row align-v="center" @click="onClickSetupHorizons">
                                        <b-col cols="10" class="unidades-header">
                                            <i class="icon-header fas"
                                                ><svg
                                                    width="21"
                                                    height="18"
                                                    viewBox="0 0 21 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M4.5 10C2.3 10 0.5 11.8 0.5 14C0.5 16.2 2.3 18 4.5 18C6.7 18 8.5 16.2 8.5 14C8.5 11.8 6.7 10 4.5 10ZM10.5 0C8.3 0 6.5 1.8 6.5 4C6.5 6.2 8.3 8 10.5 8C12.7 8 14.5 6.2 14.5 4C14.5 1.8 12.7 0 10.5 0ZM16.5 10C14.3 10 12.5 11.8 12.5 14C12.5 16.2 14.3 18 16.5 18C18.7 18 20.5 16.2 20.5 14C20.5 11.8 18.7 10 16.5 10Z"
                                                        fill="#009ADA"
                                                    /></svg
                                            ></i>
                                            <span class="title">{{
                                                $t('strategy.onepage.advancedOptions.horizons.horizonsConfig')
                                            }}</span>
                                        </b-col>
                                    </b-row>
                                </template>
                            </b-dropdown>
                        </li>
                    </b-dropdown>
                </div>
            </div>
        </div>
        <section v-if="blocos && !$route.meta.compactMode">
            <Card :listAmount="listAmount" :cards="blocos" />
        </section>
        <div class="animated fadeIn">
            <router-view @updateHorizons="loadHorizons(onepage.id)" :onePageId="onepage.id" />
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Loader from '@/views/components/loader'
import { Card, DatePicker, DropdownCheckbox, ValidationInput } from './components'
import { noMarginMixin } from '@/mixins'
import ProgressBar from '@/views/components/progress-bar/ProgressBar.vue'

export default {
    mixins: [noMarginMixin],
    name: 'OnePage',
    components: {
        Loader,
        Card,
        DatePicker,
        DropdownCheckbox,
        ProgressBar,
        ValidationInput,
    },
    data() {
        return {
            listAmount: null,
            activeWinner: null,
            activeDate: null,
            preventConfigDropdownHide: false,
            maxProgressBar: 1,
        }
    },
    computed: {
        ...mapState('strategy', {
            loading: (state) => state.loading,
            onepage: (state) => state.onepage,
            unidades: (state) => state.unitys,
            blocos: (state) => state.blocks,
        }),
        labelProgressChallenge() {
            let value = parseFloat(this.onepage.challenge).toFixed(1)
            return value
        },
        validationUserRole() {
            return this.$store.state.currentUser.user.role.id == 1
        },
        hasStrategyModule() {
            return this.$store.state.currentUser.user.company.has_strategy
        },
    },
    created() {
        this.loadUnitysAll()
        this.loadOnepage().then((data) => {
            this.loadUnitysAndBlocks({
                id: data.id,
                data: 'with=sections;blocks;attributes',
            })
            this.loadHorizons(data.id)
        })
    },
    mounted() {
        this.listAmount = this.blocos.length
    },
    directives: {
        clickOutside: {
            bind: function (el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    // here I check that click was outside the el and his children
                    if (!(el == event.target || el.contains(event.target))) {
                        // and if it did, call method provided in attribute value
                        vnode.context[binding.expression](event)
                    }
                }
                document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
        },
    },
    methods: {
        ...mapActions('strategy', [
            'loadOnepage',
            'updateOnepage',
            'loadUnitysAll',
            'loadUnitysAndBlocks',
            'updateUnity',
            'updateBlock',
            'loadHorizons',
        ]),
        putOnepage() {
            const { id, winning_strategy } = this.onepage
            const params = {
                id,
                body: {
                    winning_strategy,
                },
            }
            this.updateOnepage(params)
                .catch((err) => {
                    console.log(err)
                    this.activeWinner = false
                })
                .finally(() => {
                    setTimeout(() => {
                        this.activeWinner = null
                    }, 1000)
                })
        },
        updateUnitys(e) {
            const idsUnitys = e[0]
                .filter((unity) => {
                    if (!unity.value) {
                        return unity.id
                    }
                })
                .map((item) => {
                    return item.id
                })
            this.updateUnity({ data: e[0], idsUnitys })
        },
        updateUnitysAll(e) {
            if (e[1]) {
                const idsUnitys = e[0].map((unity) => {
                    return unity.id
                })
                this.updateUnity({ data: e[0], idsUnitys })
            } else {
                this.updateUnity({ data: e[0], idsUnitys: [] })
            }
        },
        closeModalUnitys({ data }) {
            const idsUnitys = data
                .filter((unity) => {
                    if (unity.value) {
                        return unity.id
                    }
                })
                .map((item) => {
                    return item.id
                })
            this.updateUnity({ data, idsUnitys })
        },
        updateBlocks(e) {
            this.updateBlock(e)
        },
        closeModalBlocks() {
            this.loadUnitysAndBlocks({
                id: this.onepage.id,
                data: 'with=sections;blocks;attributes',
            })
        },
        onClickSetupHorizons() {
            this.$router.push('/v2/strategy/onepage/setup-horizons')
        },
        compactModeActive(ev) {
            console.log({ ev })
        },
        preventHide(ev) {
            if (this.preventConfigDropdownHide) {
                ev.preventDefault()
            }
        },
        toggleConfigDropdown() {
            if (!this.$refs.ddown.visible) {
                this.preventConfigDropdownHide = true
            } else {
                this.preventConfigDropdownHide = false
            }
        },
        viewBlockPerformance(performance) {
            let valuePerformance = (performance * 100).toFixed(0)
            return `${valuePerformance}%`
        },
        updateColorPerformance(performance, max) {
            if (max == undefined) max = 1
            if (performance == null) performance = 0
            let valueMax = performance / max
            return valueMax == 0 ? '#BEC0C0' : valueMax < 0.3 ? '#f05050' : valueMax < 0.7 ? '#fad732' : '#27c24c'
        },
        closeAdvancedConfig() {
            if (this.$refs.ddown.visible) {
                this.preventConfigDropdownHide = false
                this.$refs.ddown.$el.classList.remove('show')
                this.$refs.ddown.$el.click()
                this.$refs.ddown.$el.querySelector('.dropdown-menu').classList.remove('show')
            }
        },
    },
}
</script>

<style scoped>
@media screen and (max-width: 1000px) {
    .title-container {
        flex-direction: column-reverse;
        row-gap: 1rem;
    }
    button.button-link {
        width: 100%;
        justify-content: center;
    }
    .config-and-progress-container {
        flex-direction: column;
        justify-content: flex-start;
        row-gap: 2rem;
    }
    .config-and-progress-container > div {
        flex-direction: column;
        row-gap: 2rem;
    }
}
.label-input {
    display: flex;
    align-items: center;
    margin-left: 0.5rem;
}
.title-container {
    display: flex;
    justify-content: space-between;
    padding-top: 1.5rem;
}
.title-content {
    display: flex;
    align-items: center;
    column-gap: 0.5rem;
    font-size: 1.4rem;
    color: #fff;
}
.title-icon {
    display: flex;
    border: 1px solid #009ada;
    border-radius: 50%;
    padding: 10px 12px;
}
.icon-save {
    font-size: 1.2rem;
    color: #86c4a0;
}
.onepage-container {
    min-height: 90vh;
    background: #fff;
}
.onepage-header {
    background: #022b4f;
    border-radius: 0 0 5px 5px;
    padding-bottom: 2rem;
}
.onepage-content {
    padding: 0 2rem;
}
#textarea {
    font-size: 2.5rem;
    color: #fff;
    background: #022b4f;
}
#textarea::placeholder {
    color: #cddae8;
}
.winner-content {
    position: relative;
    padding: 0 !important;
}
.winner-textarea {
    margin: 0.5rem 0;
    border: none;
    padding: 0.5rem 0;
}
.nav-link {
    display: flex;
    justify-content: flex-end;
    font-weight: 600;
    font-size: 1.2rem;
    padding: 0;
}
.button-link {
    min-width: 145px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    column-gap: 0.5rem;
    align-items: center;
    font-size: 1rem;
    color: #fff;
    background: #009ada;
    border: none;
    border-radius: 5px;
    padding: 10px;
    outline: none;
    transition: all 300ms;
}
.button-link:hover {
    opacity: 0.9;
}
.config-and-progress-container {
    display: flex;
    justify-content: space-between;
    padding: 0 2rem;
    margin-top: 1rem;
}
.config-and-progress-container > div {
    display: flex;
    column-gap: 3rem;
}
.progress-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 0.5rem;
}
.progress-container > div > span {
    margin-left: 0.5rem;
    color: #fff;
    font-weight: bold;
}
.progress-content {
    display: flex;
    align-items: center;
}
.progress-title {
    font-weight: normal;
    font-size: 1rem;
    color: #fff;
}
.progress-bar {
    border: 0.5px solid #bec0c0;
    background: transparent !important;
    min-width: 270px;
}
.options-content {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.advanced-config {
    color: #009ada;
}
.advanced-config > ul > li > .dropdown-toggle > .row {
    flex-wrap: no-wrap !important;
}
.advanced-button {
    color: #009ada;
}
.unidades-content {
    width: 100%;
    border-radius: 5px;
}
.icon-gray {
    font-size: 1.2rem;
    color: #6e6e6e;
    text-align: end;
}
.unidades-header {
    text-align: start;
}
.icon-header {
    color: #009ada;
    margin-right: 2rem;
}
.title {
    font-size: 1rem;
    color: #6e6e6e;
    font-weight: bold;
}
</style>
